import React from 'react';
import '../src/styles/App.css';
import Rotas from './routes/routes.js';

function App() {
    return <Rotas />;
}

export default App;
